export const BROWSER_LOCALE = navigator.language
